import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "maskIban",
  standalone: true,
})
export class MaskIbanPipe implements PipeTransform {
  transform(iban: string): string {
    if (!iban || iban.length < 8) {
      return iban;
    }
    const start = iban.slice(0, 4);
    const end = iban.slice(-3);
    const masked = "*".repeat(iban.length - 7);
    return `${start}${masked}${end}`;
  }
}
